<template>
  <section class="downloads">
    <div class="downloads__inner cia-container">
      <h2>Pobierz za darmo wersję:</h2>
      <div class="downloads__uris">
        <v-progress-circular
          v-if="macOSBusy || windowsBusy"
        indeterminate
        color="white"
      />
        <div v-if="!macOSBusy && !windowsBusy">
          <a v-if="iosApp" :href="iosApp" target="_blank">
            <img src="@/assets/IOS_logo.svg" alt="iOS App"/>
            <span>iOS</span>
          </a>
          <a v-if="androidApp" :href="androidApp"  target="_blank">
            <img src="@/assets/android-logo.svg" alt="Android App"/>
            Android
          </a>
          <a v-if="macOS" :href="macOSapp" :download="macOSapp">
            <img src="@/assets/MacOS_logo.svg" alt="macOS App"/>
            macOS
          </a>
          <a v-if="windows" :href="windowsApp" :download="windowsApp">
            <img src="@/assets/windows_logo.svg" alt="Windows App"/>
            Windows
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import getAppData from './../../repository/apps';
import config from './../../config';

const yaml = require('js-yaml');

export default {
  name: 'download-apps',
  data: () => ({
    macOS: null,
    macOSBusy: false,
    windows: null,
    windowsBusy: false,
  }),
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
    async getMacApp() {
      this.macOSBusy = true;
      try {
        const appData = await getAppData('latest-mac.yml');
        const data = yaml.safeLoad(appData.data);
        this.macOS = data.version;
        this.macOSBusy = false;
      } catch (e) {
        this.macOSBusy = false;
      }
    },
    async getWindowsApp() {
      this.windowsBusy = true;
      try {
        const appData = await getAppData('latest.yml');
        const data = yaml.safeLoad(appData.data);
        this.windows = data.version;
        this.windowsBusy = false;
      } catch (e) {
        this.windowsBusy = false;
      }
    },
  },
  computed: {
    iosApp() {
      return 'https://itunes.apple.com/pl/app/centrum-archiwizacji/id1439181886?l=pl&mt=8';
    },
    androidApp() {
      return 'https://play.google.com/store/apps/details?id=pl.netizens.cia.mobile';
    },
    macOSapp() {
      return `${config.apiUrl}/update/CIA-${this.macOS}.dmg`;
    },
    windowsApp() {
      return `${config.apiUrl}/update/CIA-${this.windows}.exe`;
    },
  },
  mounted() {
    this.getMacApp();
    this.getWindowsApp();
  },
};
</script>

<style lang="scss" scoped>
  .downloads {
    background-image: linear-gradient(80deg, #3082e5, #1456ca);
    color: #fff;
    padding: 50px 0 40px;
    @media (min-width: 550px) {
      padding: 50px 0 30px;
    }
    @media (min-width: 1000px) {
      padding: 100px 0 80px;
    }
    text-align: center;
    h2 {
      text-align: center;
      font-weight: 300;
      font-size: 26px;
      padding-bottom: 20px;
      @media (min-width: 550px) {
        font-size: 34px;
      }
      @media (min-width: 1000px) {
        font-size: 44px;
        padding-bottom: 30px;
      }
    }
    a {
      color: #fff !important;
      display: inline-block;
      padding: 10px;
      transition: 250ms opacity linear;
      font-size: 14px;
      @media (min-width: 550px) {
        padding: 20px;
        font-size: 16px;
      }
      &:hover {
        color: #fff !important;
        opacity: 0.8;
      }
      img {
        display: block;
        margin: 0 auto 10px;
        height: 30px;
        width: auto;
        @media (min-width: 550px) {
          height: 50px;
        }
      }
    }
    &__uris {
      min-height: 65px;
    }
  }
</style>
